var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"root"},[_c('pc-quick-start'),_c('pc-viewing-trace-doc')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }